import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const Icon = ({ name, className, title, size = 1 }) => {
  return (
    <Fragment>
      <span className={`fas fa-${name} ${className}`} title={title} style={{ fontSize: `${size}rem` }} role='img' />
      <span className='sr-only'>{title}</span>
    </Fragment>
  )
}

Icon.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export default Icon
